import { isAxiosError } from 'axios';

/**
 * Konkrétní důvod selhání z RFC 9457 problem details (backendový `Error.Message` → `detail`).
 *
 * Backend posílá u očekávaných business failures srozumitelnou českou větu; generický fallback v UI je
 * tedy až poslední možnost, ne výchozí zobrazení. Bez tohohle se z každé 400/409/422 stane stejná hláška
 * a uživatel nemá šanci poznat, co konkrétně brání uložení.
 *
 * Vrací `undefined`, když nejde o odpověď serveru (síť, timeout) nebo `detail` chybí — volající pak
 * ukáže svůj fallback.
 */
export function serverErrorDetail(error: unknown): string | undefined {
  if (!isAxiosError(error)) return undefined;
  const detail = (error.response?.data as { detail?: string } | undefined)?.detail;
  return detail && detail.trim().length > 0 ? detail : undefined;
}
